module.exports = __webpack_public_path__ + "static/2-b5215e9f18a554a9baffcd6cd7f48b48.png";